import React, { Component } from 'react'
import classNames from 'classnames'

class Pagination extends Component {
  constructor(props) {
    super(props)   
    this.state = { 
      current: this.props.currentPageNumber,      
      total: Math.ceil(Number(this.props.totalItemsCount) / Number(this.props.itemsCountPerPage)),
      from: Number(this.props.currentPageNumber)
    }
  }

  onClick = (n) => {
    if(this.state.current === n)
    {
      return;
    }

    this.setState({
      current: n
    })

    this.props.onPageChange(n)
  }

  onNextClick = () => {    
    const newFrom = Math.max(1, Math.min(this.state.from + 1, this.state.total - this.props.pageRangeDisplayed + 1))
    const newCurrent = Math.min(this.state.current + 1, this.state.total)
    this.onClick(newCurrent, newFrom)
  }

  onPrevClick = () => {
    const newFrom = Math.max(this.state.from - 1, 1)
    const newCurrent = Math.max(this.state.current - 1, 1)
    this.onClick(newCurrent, newFrom)
  }

  render() {
    let range = Math.min(this.props.pageRangeDisplayed, this.state.total)
    this.state.from = Math.min(this.state.from, this.state.total - range + 1)  
    let to = this.state.from + range - 1

    const nextDisabledClass = (this.state.current === this.state.total) || this.state.total === 0 ? 'pagination-disabled' : ''
    const preDisabledClass = this.state.total === 0 || (this.state.current  === 1) ? 'pagination-disabled' : ''

    let renderPageNumbers
    const pageNumbers = []    
    for (let i = this.state.from; i <= to; i++) {
      pageNumbers.push(i);
    }

    renderPageNumbers = pageNumbers.map(number => {      
      let activeClass = this.state.current === number ? 'active-page' : ''
      return (
        <span key={number} className={classNames('pagination', activeClass)} onClick={() => this.onClick(number)}>{number}</span>
      )
    })

    return (      
      <div className='pagination-wrapper'>
          <span id='pgnPre' className={classNames('pagination', preDisabledClass)} onClick={() => this.onPrevClick()}>&lt;</span>
          {renderPageNumbers}
          <span id='pgnNext' className={classNames('pagination', nextDisabledClass)} onClick={() => this.onNextClick()}>&gt;</span>
       </div>
    )
  }
}

export default Pagination

